import { HttpInterceptorFn } from '@angular/common/http';


/**
 * Intercepts all HTTP request and attaches the JWT token in the Authorisation header
 * @author Brayan Cataño
 */

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // const token = sessionStorage.getItem('token');
  const clonedRequest = req.clone({
    withCredentials: true
  });
  return next(clonedRequest);
};
